export default __webpack_public_path__ + "static/media/ugo-outlet.649e476c.svg";